import { InjectionToken } from '@angular/core';
import { SecurityExternalSettings } from './security-external-settings';

export const WidgetSettingsToken = new InjectionToken('GoldenLayoutComponentState');

export const SECURITY_EXTERNAL_SETTINGS = new InjectionToken<SecurityExternalSettings>(
  'security_external_settings'
);
